module.exports = "https://r.nearpod.com/assets/media/image/live_participation-1e687cf2b0417fbbef7085f93de8977b.svg";